import { KirbyCheck, KirbyCheckGroup, KirbyDemoContent, KirbyInfoGeneral, KirbyInfoPlus } from '@solid/shared/kirby';
import { useQuery } from '@tanstack/react-query';
import {
  KIRBY_CACHE_KEY,
  getKirbyCheckGroups,
  getKirbyChecks,
  getKirbyInfoGeneral,
  getKirbyDemoContent,
  getKirbyInfoPlus,
  getKirbyPlaceholderDataFromCache,
} from '../services/kirby.service';
import { useContext } from 'react';
import { AuthContext } from '../contexts/auth.context';
import { getLocalStorageKey } from '../services/local-storage.service';
import { LOCAL_STORAGE_LANGUAGE_KEY } from '../i18n/i18n';

export const useKirbyCheckGroups = () => {
  const { auth } = useContext(AuthContext);
  const language = getLocalStorageKey(LOCAL_STORAGE_LANGUAGE_KEY);
  return useQuery(['kirby-check-groups', auth?.user.id, language], getKirbyCheckGroups, {
    placeholderData: getKirbyPlaceholderDataFromCache(KIRBY_CACHE_KEY.CHECK_GROUPS) as KirbyCheckGroup[],
    staleTime: Infinity,
  });
};

export const useKirbyInfoGeneral = () => {
  const language = getLocalStorageKey(LOCAL_STORAGE_LANGUAGE_KEY);
  return useQuery(['kirby-info-general', language], getKirbyInfoGeneral, {
    placeholderData: getKirbyPlaceholderDataFromCache(KIRBY_CACHE_KEY.INFO_GENERAL) as KirbyInfoGeneral,
    staleTime: Infinity,
  });
};

export const useKirbyDemoContent = () => {
  const language = getLocalStorageKey(LOCAL_STORAGE_LANGUAGE_KEY);
  return useQuery(['kirby-demo-conent-v2', language], getKirbyDemoContent, {
    placeholderData:
      (getKirbyPlaceholderDataFromCache(KIRBY_CACHE_KEY.DEMO_CONTENT) as KirbyDemoContent | undefined) ?? {
        online_demo: null,
        online_demo_title: null,
        online_demo_iframe_url: null,
        online_demo_iframe_show: null,
        online_content: null,
        online_content_show: null,
        online_demo_video_active: null,
        online_demo_video_url: null,
        online_demo_video_autoplay: null,
      },
    staleTime: Infinity,
  });
};


export const useKirbyInfoPlus = () => {
  const { auth } = useContext(AuthContext);
  const language = getLocalStorageKey(LOCAL_STORAGE_LANGUAGE_KEY);
  return useQuery(['kirby-info-plus', auth?.user.id, language], getKirbyInfoPlus, {
    placeholderData: getKirbyPlaceholderDataFromCache(KIRBY_CACHE_KEY.INFO_PLUS) as KirbyInfoPlus,
    staleTime: Infinity,
    enabled: auth?.user.id !== undefined,
  });
};

export const useKirbyChecks = () => {
  const { auth } = useContext(AuthContext);
  const language = getLocalStorageKey(LOCAL_STORAGE_LANGUAGE_KEY);
  return useQuery(['kirby-checks', auth?.user.id, language], () => getKirbyChecks(), {
    placeholderData: getKirbyPlaceholderDataFromCache(KIRBY_CACHE_KEY.CHECKS) as KirbyCheck[],
    staleTime: Infinity,
    enabled: auth?.user.id !== undefined,
  });
};
